import { Helmet } from 'react-helmet';
import { Outlet } from 'react-router-dom';
import './Uptime.scss';
import './Uptime.css';

export default function Uptime() {
  return (
    <>
      <Helmet>
        <title>Device Status | Titan Secure</title>
        <meta name="description" content="Monitor device uptime and status" />
      </Helmet>
      <div className="uptime">
        <h1>Device Status Monitor</h1>
        <div className="uptime__content">
          <Outlet />
        </div>
      </div>
    </>
  );
} 